import React, { useState, useEffect } from 'react'
import { Drawer } from 'antd'
import { useTranslation } from 'react-i18next'
import Moment from 'react-moment'
import Icons from '@commonComponents/Icons'
import { getOperationalModel } from '../../../../flag-management/flag-management.tools'
import { getPhotoUrl } from '../../../flag-management.services'

const TRUCK = 'Truck'
const CHECK_CIRCLE = 'CheckCircle'
const IMAGE_ICON = 'Image'
const RETRY_LIMIT = 3
const DEFAULT_IMAGE = 'delivery_package.png'
let numOfRetries = 0

const DeliveryDetail = (props) => {
  const { t } = useTranslation()
  const { job, contactLess, tz } = props
  const { operationModel } = job
  const { comment, cashReceiver, phoneNumber, photoUrl, photoTakenAt } = contactLess
  const [imageUrl, setImageUrl] = useState('')

  useEffect(() => {
    const generateImageUrl = async () => {
      const image = await getPhotoUrl(job.id)
      if (image) {
        const { url } = image
        if (numOfRetries < RETRY_LIMIT && url.includes('https://s3.amazonaws.com/')) {
          numOfRetries += 1
          return generateImageUrl()
        }
        return url
      }
      return null
    }

    const getImage = async () => {
      if (photoUrl.search(DEFAULT_IMAGE) > 0) {
        setImageUrl(photoUrl)
      } else {
        const image = await generateImageUrl()
        if (image) {
          setImageUrl(image)
        }
      }
    }

    if (props.visible && photoUrl) {
      numOfRetries = 0
      getImage()
    }
  }, [job.id, photoUrl, props.visible])

  return (
    <Drawer
      title={t('jobs.job.info.devDetails')}
      width={500}
      onClose={props.handleDeliveryDetails}
      visible={props.visible}
    >
      <div>
        <dd className='secondary-text'>
          <Icons iconName={TRUCK} /> {getOperationalModel(t)[operationModel]}
        </dd>
        <dt className='secondary-text'>
          <Icons iconName={CHECK_CIRCLE} /> {t('jobs.job.info.noContact')}
        </dt>
        <div className='contact-less-info'>
          <dl>
            <dt>{t('jobs.job.info.leave')}:</dt>
            <dd className='secondary-text'>{t(`${comment}`)}</dd>
          </dl>
          {cashReceiver && (
            <dl>
              <dt>{t('jobs.job.info.leaveCash')}:</dt>
              <dd className='secondary-text'>
                {cashReceiver}
                <br />
                {`${t('jobs.job.info.contactLess.phone')} ${phoneNumber}`}
              </dd>
            </dl>
          )}
        </div>
        <dd className='secondary-text'>
          <Icons iconName={IMAGE_ICON} /> {t('jobs.job.info.devPhoto')}
        </dd>
        {imageUrl ? (
          <dd style={{ display: 'grid' }} className='secondary-text'>
            <img style={{ width: '60%' }} src={imageUrl} alt='evidence' />
            {photoTakenAt && (
              <span style={{ marginTop: '.5em' }}>
                {`${t('jobs.job.info.contactLess.photoTakenAt')} `}
                <br />
                <Moment format='LLL' tz={tz}>
                  {photoTakenAt}
                </Moment>
              </span>
            )}
          </dd>
        ) : (
          <img style={{ marginLeft: '1em' }} src='/image-empty.png' alt='Empty' />
        )}
      </div>
    </Drawer>
  )
}

export default DeliveryDetail
